import './style.scss'

import React, { Component } from 'react'

import DeliveryDate from 'components/DeliveryDate'
import DropDown from 'components/UI/DropDown'
import Icon from 'components/UI/Icon'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import clockIcon from 'theme/icons/clock.svg'
import { connect } from 'react-redux'
import { getDateAsText } from 'utilities/date'
import { toggleDeliveryDateDropdown } from 'actions/UI'
import { withTranslation } from 'react-i18next'

export class DeliveryDateDropdown extends Component {
    handleClick() {
        if (!this.props.isSubscriptionMode) {
            this.props.dispatch(toggleDeliveryDateDropdown())
        }
    }

    render() {
        const { dispatch, title, expanded, isSubscriptionMode, t } = this.props
        const classes = classNames({
            'delivery-date-dropdown': true,
            'delivery-date-dropdown--expanded': expanded,
        })
        return (
            <div className={classes}>
                <DropDown
                    title={
                        isSubscriptionMode
                            ? t('deliveryDateTitleFastLevering')
                            : title
                            ? title
                            : t('chooseDate')
                    }
                    icon={<Icon svg={clockIcon} size="medium" />}
                    expanded={expanded}
                    disabled={isSubscriptionMode}
                    onClose={() => dispatch(toggleDeliveryDateDropdown(false))}
                    onClick={() => this.handleClick()}
                >
                    <h1 className="delivery-date-dropdown__heading">
                        {t('deliveryDateDropdownHeading')}
                    </h1>
                    <DeliveryDate onDateSelected={() => dispatch(toggleDeliveryDateDropdown())} />
                </DropDown>
            </div>
        )
    }
}

DeliveryDateDropdown.propTypes = {
    title: PropTypes.string,
    expanded: PropTypes.bool,
    isSubscriptionMode: PropTypes.bool,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

const mapStateToProps = ({ checkout, ui, subscription }) => {
    return {
        title: getDateAsText(checkout.deliveryDate),
        expanded: ui.showDeliveryDatesDropdown,
        isSubscriptionMode: subscription.isSubscriptionMode,
    }
}

export default connect(mapStateToProps)(withTranslation()(DeliveryDateDropdown))
